module.exports = __webpack_public_path__ + "static/img/new6-Kp9wQm2E.d20b025.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/new6-Kp9wQm2E.png
// module id = 0Rdu
// module chunks = 16